<div class="card bg-white">
  <div class="card-header bg-primary text-center">
    <h4 class="text-white mb-0 page-heading"><span class="-thin">Manual bid input for </span><span
        class="fw-bold">{{supplier.name}}</span></h4>
  </div>
  <jft-input-bid-steps></jft-input-bid-steps>
</div>

<router-outlet></router-outlet>
